module.exports = __webpack_public_path__ + "static/img/mifi_back02.14a9ab72.png";